import React from 'react';

// Кнопка с улучшенными стилями
const Button = ({ children, className, ...props }) => (
  <button
    className={`bg-gradient-to-r from-red-600 via-red-500 to-red-400 text-white py-3 px-6 rounded-xl shadow-2xl transform hover:scale-105 hover:from-red-700 hover:to-red-500 transition-all duration-300 ease-in-out focus:outline-none ${className}`}
    {...props}
  >
    {children}
  </button>
);

export default Button;
